// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-1mV_X"};